/**
 * MessageIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MessageIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M16 3H8a7 7 0 0 0 0 14h.88l1.78 3.55a1.44 1.44 0 0 0 2.68 0L15.12 17H16a7 7 0 1 0 0-14m0 12h-2.12L12 18.76 10.12 15H8A5 5 0 0 1 8 5h8a5 5 0 0 1 0 10" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MessageIcon = makeIcon('MessageIcon', MessageIconSvg)
